import dynamic from "next/dynamic";

export const SectorSkillsMobile = dynamic(() => import("./component"));
